import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {PRICE_CHANGE_REASON} from './price-change-reason.constants';

@Component({
  selector: 'app-price-change-reason-selector',
  templateUrl: './price-change-reason-selector.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class PriceChangeReasonSelectorComponent implements OnInit, OnDestroy {

  @Input() formGroup: FormGroup;
  @Input() disabled = false;
  @Input() isInitialPrice = false;
  @Input() choices: Record<string, string> = {};

  choiceEntries: [string, string][] = [];

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.choiceEntries = Object.entries(this.choices ?? {});

    const defaultReason = this.isInitialPrice ? PRICE_CHANGE_REASON.INITIAL_PRICE_SETTING : '';

    if (!this.formGroup.contains('priceChangeReason')) {
      this.formGroup.addControl('priceChangeReason', this.formBuilder.control(defaultReason, [Validators.required]));
    }

    if (!this.formGroup.contains('priceChangeDescription')) {
      this.formGroup.addControl('priceChangeDescription', this.formBuilder.control(''));
    }

    this.updateDescriptionValidation();
  }

  ngOnDestroy(): void {
    if (this.formGroup.contains('priceChangeReason')) {
      this.formGroup.removeControl('priceChangeReason');
    }
    if (this.formGroup.contains('priceChangeDescription')) {
      this.formGroup.removeControl('priceChangeDescription');
    }
  }

  onReasonChange(): void {
    this.updateDescriptionValidation();

    if (this.formGroup.controls['priceChangeReason'].value !== PRICE_CHANGE_REASON.OTHER) {
      this.formGroup.controls['priceChangeDescription'].setValue('');
    }
  }

  get isOtherSelected(): boolean {
    return this.formGroup.controls['priceChangeReason']?.value === PRICE_CHANGE_REASON.OTHER;
  }

  private updateDescriptionValidation(): void {
    const descriptionControl = this.formGroup.controls['priceChangeDescription'];
    if (this.isOtherSelected) {
      descriptionControl.setValidators([Validators.required, Validators.maxLength(5000)]);
    } else {
      descriptionControl.clearValidators();
    }
    descriptionControl.updateValueAndValidity();
  }
}
